
import React, { useState, useEffect } from 'react';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '../Checkbox';
import Button from '../Button';
import Switch from '../Switch';
import IconButton from '../IconButton';
import Input from '../Input';
import Popover from '@material-ui/core/Popover';
import { DateRange } from 'react-date-range';
import Modal from '../Modal';
import { getDaysOfWeekForRange, formatSlot } from '../../utils/shopUtils';
import { mainColor, DAYS } from '../../constants';
import moment from 'moment';
import UpdateIcon from '@material-ui/icons/Create';
import _ from 'lodash';
import { parseDate } from '../../utils/suitableDate';
import { handleChangeSwitch, changeFullDay, handleChangeHours, handleActivateSection, handleChangeDate, onSelectDate, submitActivationRange, handleAddSlots, handleRemoveSlot, sortSlots } from './ActivationRange.services';
import { styles } from './Activation.styles';
import AddIcon from '@material-ui/icons/Add';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import locale from 'date-fns/locale/fr/index.js';
interface ActivationRangeProps {
  item: any;
  setState: any;
  classes: any;
}

const ActivationRange: React.FC<ActivationRangeProps> = ({ item, setState, classes }) => {
  const [hasRangeDate, setHasRangeDate] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [slotErrorMessages, setSlotErrorMessages] = useState<string[]>([]);
  const [selectedDate, setSelectedDate] = useState<string>('');
  const [activationRange, setActivationRange] = useState<any>(null);
  const [open, setOpen] = useState(false);
  const [anchorElDate, setAnchorElDate] = useState<any>(null);
  const [selection, setSelection] = useState({
    startDate: moment().startOf('day').toDate(),
    endDate: moment().endOf('day').subtract(1, 'minute').toDate(),
    key: 'selection'
  });

  useEffect(() => {
    if (item) {
      setHasRangeDate(item.activationRange?.withDateRange);
      setSelection({
        startDate: moment(item.activationRange?.startDate).startOf('day').toDate() || moment().startOf('day').toDate(),
        endDate: moment(item.activationRange?.endDate).endOf('day').toDate() || moment().endOf('day').toDate(),
        key: 'selection'
      });
    }
  }, []);

  const renderDays = (sectionActivationRange: any) => {
    const daysOfWeekForRange = getDaysOfWeekForRange(selection.startDate, selection.endDate);
    return (
      <>
        <p>Plages d'activations par jour</p>
        <p className={classes.hrStyle}></p>
        <div style={{ width: '100%' }}>
          {_.keys(DAYS).map((e) => {
            const slots = sectionActivationRange?.daysOfWeek?.[e]?.slots || [];
            const isFullDay = sectionActivationRange?.daysOfWeek?.[e]?.fullDay || false;
            return (
              <div
                key={e}
                style={{ marginBottom: '-5px' }}
                className="row d-flex align-items-center justify-content-between mx-0"
              >
                <div className="d-flex align-items-center col-3 pl-0">
                  <Switch
                    size="small"
                    onChange={(event) => handleChangeSwitch(e, event, setState)}
                    checked={sectionActivationRange?.daysOfWeek?.[e]}
                    disabled={sectionActivationRange && daysOfWeekForRange.indexOf(e) === -1}
                  />
                  <div className={classes.dayLabel}>{DAYS[e]}</div>
                </div>
                <div className={`${classes.slotStyle} col-5 ${_.size(slots) > 1 ? 'my-2' : ''}`}>
                  {sectionActivationRange?.daysOfWeek && (
                    isFullDay ? (
                      <p className={classes.dayLabel}>Toute la journée</p>
                    ) : (
                      _.map(sortSlots(slots), (slot) => (
                        <div key={slot} >
                          <p>{formatSlot(slot)}</p>
                        </div>
                      ))
                    )
                  )}
                </div>
                <IconButton
                  label="Modifier"
                  className={`${classes.icon} ${classes.slots}`}
                  onClick={() => {
                    setOpenEditModal(true);
                    setSelectedDate(e);
                    setActivationRange(_.cloneDeep(sectionActivationRange))
                  }}
                  disabled={!sectionActivationRange?.daysOfWeek?.[e]}
                >
                  <UpdateIcon className={classes.updateIcon} />
                </IconButton>

              </div>
            );
          })}
          <Modal
            isOpen={openEditModal}
            handleClose={() => {
              setSlotErrorMessages([]);
              setOpenEditModal(!openEditModal);
            }}
            color="secondary"
            title={`Plage d'activation pour le ${DAYS[selectedDate]}`}
            header
            width="565px"
            size="md"
            modalBodyClass="py-0"
            onClick={() =>
              submitActivationRange(
                activationRange,
                activationRange.daysOfWeek[selectedDate],
                setState,
                setSlotErrorMessages,
                () => setOpenEditModal(!openEditModal),
              )
            }
          >
            {renderSlots(selectedDate)}
          </Modal>
        </div>
        <p className={classes.hrStyle}></p>
      </>
    );
  };



  const renderSlots = (day: string) => {
    const fullDay = activationRange?.daysOfWeek[day]?.fullDay || false;
    const slots = activationRange?.daysOfWeek[day]?.slots || ['00:00-23:59'];

    return (
      <div className="row mx-0 px-0 py-1 w-100  justify-content-center align-items-center">
        <div className="col-sm-5 px-0 mx-0 d-flex justify-content-center align-items-center">
          <Switch
            onChange={(event) =>
              changeFullDay(event, activationRange, day, setActivationRange, setSlotErrorMessages)
            }
            checked={fullDay}
          />
          <div>Disponible toute la journée</div>
        </div>
        <div className="col-sm-2 d-flex flex-column justify-content-center align-items-center mb-3 mb-sm-0">
          <div className={classes.choiceText}>(ou)</div>
        </div>
        <div className="col-sm-5 d-flex flex-column justify-content-center align-items-center">
          <div
            style={{ color: fullDay ? mainColor.colorClearGray : mainColor.colorBlack }}
          >
            Ajouter un créneau horaire :
          </div>
          <IconButton
            label="Add"
            className={classes.iconStyle}
            disabled={fullDay}
            onClick={() => handleAddSlots(activationRange, day, setActivationRange)}
            style={{
              color: mainColor.colorWhite,
              backgroundColor: fullDay ? mainColor.colorClearGray : `rgba(${mainColor.rgb}, 0.8)`,
            }}
          >
            <AddIcon className={classes.addIcon} />
          </IconButton>
          {slots &&
            !fullDay &&
            slots.map((slot, index) => {
              const [startTime, endTime] = slot?.split('-') || [];

              return (
                <div key={`${day}-${index}`} className="row d-flex justify-content-center align-items-center py-2">
                  <Input
                    type="time"
                    value={startTime}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={fullDay}
                    onChange={(event) =>
                      handleChangeHours(
                        day,
                        event.target.value,
                        'start',
                        activationRange,
                        slot,
                        index,
                        setActivationRange,
                        setSlotErrorMessages
                      )
                    }
                    error={slotErrorMessages[index]}
                  />

                  <div
                    className={classes.textField}
                    style={{ color: fullDay ? mainColor.colorClearGray : mainColor.colorBlack }}
                  >
                    à
                  </div>

                  <Input
                    type="time"
                    value={endTime}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={fullDay}
                    onChange={(event) =>
                      handleChangeHours(
                        day,
                        event.target.value,
                        'end',
                        activationRange,
                        slot,
                        index,
                        setActivationRange,
                        setSlotErrorMessages
                      )
                    }
                    error={Boolean(slotErrorMessages[index])}
                  />

                  <div className="d-flex">
                    <IconButton
                      label="Remove"
                      className={classes.icon}
                      onClick={() => handleRemoveSlot(activationRange, index, day, setActivationRange, setSlotErrorMessages)}
                      style={{ alignSelf: 'flex-end' }}
                      disabled={slots.length === 1}
                    >
                      <DeleteOutlinedIcon className={classes.removeButton} />
                    </IconButton>
                  </div>

                  <div className={slotErrorMessages[index] && slotErrorMessages[index].includes('identiques') ? `${classes.errorMessage} pl-2` : !slotErrorMessages[index] ? '' : classes.slotError} >
                    <span>{slotErrorMessages[index]}</span>
                  </div>
                </div >
              );
            })}

        </div >
      </div >
    );
  };


  return (
    <>
      <div className={`row w-100 d-flex align-items-center justify-content-between mx-0 `}>
        <div className='d-flex align-items-center'>
          <Checkbox
            value={hasRangeDate}
            text={`Définir une plage d'activation`}
            name='withDateRange'
            onClick={() => handleActivateSection(hasRangeDate, selection, setState, setHasRangeDate)}
          />
        </div>
        {hasRangeDate &&
          <>
            <div className='d-flex align-items-center mt-2'>
              <Button
                color='secondary'
                outlined
                className='btn-xs-block'
                onClick={event => handleChangeDate(event, open, setOpen, setAnchorElDate)}
                disabled={!hasRangeDate}
              >
                <div className='row ml-0 mr-0 justify-content-center'>
                  {parseDate(selection.startDate, selection.endDate)}
                  <ArrowDropDownIcon className={classes.arrowIcon} />
                </div>
              </Button>
            </div>
            {renderDays(item.activationRange)}
          </>
        }
      </div>
      <Popover
        open={open}
        anchorEl={anchorElDate}
        onClose={() => {
          setOpen(false);
        }}
      >
        <DateRange
          minDate={moment().toDate()}
          editableDateInputs={true}
          locale={locale}
          onChange={ranges => onSelectDate(ranges, hasRangeDate, setState, setSelection)}
          rangeColors={[mainColor.secondaryColor]}
          color={mainColor.secondaryColor}
          moveRangeOnFirstSelection={false}
          ranges={[selection]}
        />
      </Popover>
    </>
  );
}

export default (withStyles(styles)(ActivationRange));